import axios from 'axios';
import cloneDeep from "lodash/cloneDeep";
import compact from "lodash/compact";
import get from "lodash/get";
import has from "lodash/has";
import hasIn from "lodash/hasIn";
import head from "lodash/head";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import moment from "moment";
import "moment/locale/es";
import React from "react";
import { Link } from "react-router-dom";
import SimpleCrypto from "simple-crypto-js";

// Redux
import store from '../app/store';
import { alertMobileNotification, logOut } from '../redux/actions/accountActions';
import { clearAdmin } from '../redux/actions/adminActions';
import { showNormalNotification } from '../redux/actions/notificationsActions';

// Constants
import { ENV } from '../constants/app';
import { LOGIN } from '../constants/endpoints';
import { CFDI_FOUR_VERSION, CFDI_THREE_VERSION } from '../constants/cfdi';
import { GENERIC_TAX_PROFILES } from '../constants/customer';
import {
  CONEKTA_INTEGRATION_ID,
  INTEGRATION_IS_ACTIVE,
  MAXIMUN_AMOUNT_TO_PAY_OXXO,
  MINIMUM_AMOUNT_TO_PAY,
  OXXO_INTEGRATION_ID,
  PAYMENT_INSTRUCTIONS_ID
} from '../constants/integrations';
import { CONCEPT_MAX_LENGTH, VALID_CFDI_USAGE_BY_TAX_REGIME } from '../constants/invoices';
import { IDENTIFYCONFIG } from "../constants/segment";

import moral_person_v3 from '../redux/resources/moral_person_v3.3';
import moral_person_v4 from '../redux/resources/moral_person_v4.0';
import physical_person_v3 from '../redux/resources/physical_person_v3.3';
import physical_person_v4 from '../redux/resources/physical_person_v4.0';

import isPhysicalPerson from './validateRfc';

/** ##########################
 * Project utils
 ########################## */

export function noEmptyField(field, def){
  if(!field || field == '') return def
  else return field
}

export function paidReceipts(invoices){
  const counterStatusFive = invoices.filter( invoice => invoice.status_id === 5 );
  const counter = counterStatusFive.length;
  return counter;
}

export function startDateReceipt (invoices) {
  if (invoices.length === 1) {
    const formattedStartDate = getDate(get(invoices[0], 'issue_date'), 'No disponible');
    return formattedStartDate;
  } else if (invoices.length > 1) {
    invoices.sort((a, b) => b.due_date - a.due_date)
    const firstNotCancelledInv = invoices.find( invoice => invoice.status_id != 6 )
    if (firstNotCancelledInv) {
      const formattedStartDate = getDate(get(firstNotCancelledInv, 'issue_date'), 'No disponible');
      return formattedStartDate;
    } else {
      return 'No disponible';
    }
  } else {
    return 'No disponible';
  }
}

export function endDateReceipt (invoices) {
  if (invoices.length === 1) {
    const formattedStartDate = getDate(get(invoices[0], 'due_date'), 'No disponible');
    return formattedStartDate;
  } else if (invoices.length > 1) {
    invoices.sort((a, b) => b.due_date - a.due_date)
    const firstNotCancelledInv = invoices.find( invoice => invoice.status_id != 6 )
    if (firstNotCancelledInv) {
      const formattedStartDate = getDate(get(firstNotCancelledInv, 'due_date'), 'No disponible');
      return formattedStartDate;
    } else {
      return 'No disponible';
    }
  } else {
    return 'No disponible';
  }
}

export function getStartEndDates (invoices) {
  let due_date, overdue_date, extension_date
  if (invoices.length === 1) {
    due_date = get(invoices[0], 'due_date')
    overdue_date = get(invoices[0], 'overdue_date')
    extension_date = get(invoices[0], 'extension_date')
  } else if (invoices.length > 1) {
    invoices.sort((a, b) => b.due_date - a.due_date)
    const firstNotCancelledInv = invoices.find( invoice => invoice.status_id != 6 )

    if (firstNotCancelledInv) {
      due_date = get(firstNotCancelledInv, 'due_date')
      overdue_date = get(firstNotCancelledInv, 'overdue_date')
      extension_date = get(firstNotCancelledInv, 'extension_date')
    } 
  }
  return  {
    due_date: getDate(due_date, 'No disponible'),
    overdue_date: getDate(overdue_date, 'No disponible'),
    extension_date: getDate(extension_date, 'No disponible')
  }
}

/**
 * parsePolicyIdentifier - Parse identifier
 * @param {string} office_id Office
 * @param {string} product_id Product
 * @param {string} policy_id Policy number
 */
export function parsePolicyIdentifier(office_id, product_id, policy_id){
  return `${office_id}-${product_id}-${policy_id}`
}

function returnPolicyId(identifier) {
  let patter = 'product_id'; // Ramo, splitter
  let newPatter = null; // Ramo, display
  let newIdentifier = null; // Identificador dinamico

  /**
   * returnParsePolicyId - Return new data for newIdentifier and newPatter
   * @param {string} id identifier
   * @param {string} product product_id
   */
  function returnParsePolicyId(id, product) {
    newIdentifier = id.replace(product, patter); // Auto
    newPatter = product;
  }

  if (identifier !== null) {
    if (identifier.includes('211')) {
      returnParsePolicyId(identifier, '211'); // Auto
    } else if (identifier.includes('420')) {
      returnParsePolicyId(identifier, '420'); // Hogar
    } else if (identifier.includes('430')) {
      returnParsePolicyId(identifier, '430'); // Empresa
    } else if (identifier.includes('501')) {
      returnParsePolicyId(identifier, '501'); // Responsabilidad Civil
    } else if (identifier.includes('606')) {
      returnParsePolicyId(identifier, '606'); // Gastos Medicos
    } else if (identifier.includes('901')) {
      returnParsePolicyId(identifier, '901'); // Vida Individual
    } else if (identifier.includes('902')) {
      returnParsePolicyId(identifier, '902'); // Vida Grupo
    } else if (identifier.includes('607')) {
      returnParsePolicyId(identifier, '607'); // Gastos Médicos Colectivo
    } else if (identifier.includes('601')) {
      returnParsePolicyId(identifier, '601'); // AP individual
    } else if (identifier.includes('605')) {
      returnParsePolicyId(identifier, '605'); // AP colectivo
    } else if (identifier.includes('201')) {
      returnParsePolicyId(identifier, '201'); // Movilidad
    } else if (identifier.includes('202')) {
      returnParsePolicyId(identifier, '202'); // Movilidad
    } else if (identifier.includes('205')) {
      returnParsePolicyId(identifier, '205'); // Movilidad
    } else if (identifier.includes('204')) {
      returnParsePolicyId(identifier, '204'); // Movilidad
    } else if (identifier.includes('203')) {
      returnParsePolicyId(identifier, '203'); // Movilidad
    } else if (identifier.includes('907')) {
      returnParsePolicyId(identifier, '907');
    } else if (identifier.includes('101')) {
      returnParsePolicyId(identifier, '101');
    } else if (identifier.includes('301')) {
      returnParsePolicyId(identifier, '301');
    } else if (identifier.includes('302')) {
      returnParsePolicyId(identifier, '302');
    } else if (identifier.includes('400')) {
      returnParsePolicyId(identifier, '400');
    } else if (identifier.includes('403')) {
      returnParsePolicyId(identifier, '403');
    } else if (identifier.includes('405')) {
      returnParsePolicyId(identifier, '405');
    } else if (identifier.includes('411')) {
      returnParsePolicyId(identifier, '411');
    } else if (identifier.includes('503')) {
      returnParsePolicyId(identifier, '503');
    } else if (identifier.includes('421')) {
      returnParsePolicyId(identifier, '421');
    } else if (identifier.includes('402')) {
      returnParsePolicyId(identifier, '402');
    } else if (identifier.includes('407')) {
      returnParsePolicyId(identifier, '407');
    } else if (identifier.includes('409')) {
      returnParsePolicyId(identifier, '409');
    } else if (identifier.includes('413')) {
      returnParsePolicyId(identifier, '413');
    } else if (identifier.includes('702')) {
      returnParsePolicyId(identifier, '702');
    } else if (identifier.includes('105')) {
      returnParsePolicyId(identifier, '105');
    } else if (identifier.includes('206')) {
      returnParsePolicyId(identifier, '206');
    } else if (identifier.includes('210')) {
      returnParsePolicyId(identifier, '210');
    } else if (identifier.includes('220')) {
      returnParsePolicyId(identifier, '220');
    } else if (identifier.includes('303')) {
      returnParsePolicyId(identifier, '303');
    } else if (identifier.includes('401')) {
      returnParsePolicyId(identifier, '401');
    } else if (identifier.includes('404')) {
      returnParsePolicyId(identifier, '404');
    } else if (identifier.includes('406')) {
      returnParsePolicyId(identifier, '406');
    } else if (identifier.includes('410')) {
      returnParsePolicyId(identifier, '410');
    } else if (identifier.includes('412')) {
      returnParsePolicyId(identifier, '412');
    } else if (identifier.includes('422')) {
      returnParsePolicyId(identifier, '422');
    } else if (identifier.includes('431')) {
      returnParsePolicyId(identifier, '431');
    } else if (identifier.includes('502')) {
      returnParsePolicyId(identifier, '502');
    } else if (identifier.includes('602')) {
      returnParsePolicyId(identifier, '602');
    } else if (identifier.includes('608')) {
      returnParsePolicyId(identifier, '608');
    } else if (identifier.includes('610')) {
      returnParsePolicyId(identifier, '610');
    } else if (identifier.includes('701')) {
      returnParsePolicyId(identifier, '701');
    } else if (identifier.includes('801')) {
      returnParsePolicyId(identifier, '801');
    } else if (identifier.includes('810')) {
      returnParsePolicyId(identifier, '810');
    } else if (identifier.includes('903')) {
      returnParsePolicyId(identifier, '903');
    } else if (identifier.includes('905')) {
      returnParsePolicyId(identifier, '905');
    } else if (identifier.includes('908')) {
      returnParsePolicyId(identifier, '908');
    } else if (identifier.includes('909')) {
      returnParsePolicyId(identifier, '909');
    } else if (identifier.includes('931')) {
      returnParsePolicyId(identifier, '931');
    } else if (identifier.includes('990')) {
      returnParsePolicyId(identifier, '990');
    } else if (identifier.includes('998')) {
      returnParsePolicyId(identifier, '998');
    } else if (identifier.includes('999')) {
      returnParsePolicyId(identifier, '999');
    } else {
      newIdentifier = identifier;
    }
  }

  return { patter, newPatter, newIdentifier };
}

/**
 * parsePolicyId - Parse identifier
 * @param {string} identifier identifier
 * @param {string} product_id
 * @param {string} office_id
 * @param {string} policy_id
 */
export function parsePolicyId(identifier, product_id = null, office_id = null, policy_id = null) {
  // First, use 
  if (product_id && office_id && policy_id) {
    return `${office_id}-${product_id}-${policy_id}`;
  }

  // Old logic
  let { patter, newPatter, newIdentifier } = returnPolicyId(identifier);
  let elements = newIdentifier ? newIdentifier.split(patter) : [newIdentifier];

  if(elements[0] === identifier) return identifier ? identifier : 'No Disponible';
  else return `${elements[0]}-${newPatter}-${elements[1]}`;
}

/**
 * getPolicyNumber - Return the policy number
 * @param {string} identifier identifier
 */
export function getPolicyNumber(identifier){
  let { patter, newIdentifier } = returnPolicyId(identifier);

  let elements = newIdentifier ? newIdentifier.split(patter) : [newIdentifier]

  if(elements[0] === newIdentifier) return 'No Disponible'
  else return elements[1]
}

export function thunkHandler(
  dispatch,
  payload,
  SUCCESS_EVENT,
  ERROR_EVENT,
  retVal
) {
  if (!!SUCCESS_EVENT && typeof SUCCESS_EVENT !== "string")
    throw "thunkHandler: SUCCESS_EVENT must be of type String";
  if (!!ERROR_EVENT && typeof ERROR_EVENT !== "string")
    throw "thunkHandler: ERROR_EVENT must be of type String";

  if (!!payload) {
    dispatch({ type: SUCCESS_EVENT, payload: payload });
    return Promise.resolve(retVal || payload);
  } else {
    const error = new Error("Bad payload");
    console.error(
      `ERROR_EVENT ${ERROR_EVENT}, SUCCESS_EVENT: ${SUCCESS_EVENT} > ${error}`
    );
    dispatch({ type: ERROR_EVENT, payload: error });
    return Promise.reject(error);
  } // END if
} // END thunkHandler

export function thunkErrorHanlder(error, dispatch, ERROR_EVENT) {
  if (!!ERROR_EVENT && typeof ERROR_EVENT !== "string")
    throw "thunkErrorHanlder: ERROR_EVENT must be of type String";

  if (typeof dispatch !== "function") console.error(error);
  else {
    if ( get(error, "response.status", "No disponible") === 400 && get(error, "response.data.message", "No disponible") === 'Rfc not found') {
      dispatch(showNormalNotification({ color: 'danger', message: 'RFC no es válido' }));
    }
    dispatch({ type: ERROR_EVENT, payload: error });
  }
} // END thunkErrorHanlder

export function sortDates(datesArr) {
  if (datesArr.length === 1) return datesArr;
  return JSON.parse(JSON.stringify(datesArr)).sort(function (date1, date2) {
    var a = new Date(date1),
      b = new Date(date2);

    if (a > b) return 1;
    if (a < b) return -1;

    return 0;
  }); // END sortedDates
} // sortDates

export function getRandomDate(start, end, localeDate) {
  let date = new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
  if (localeDate) return date.toLocaleDateString();
  else date;
} // getRandomDate

/**
 * Parse URL:  ":param" to  "/param/"
 * PARAMS:
 *  @url           {string}   traget url
 *  @urlParams     {object}   url params to replace
 *  @queryString   {object}   will add object to query string, first element in object: ?, others: &
 *  @return        {string}   parsed url
 */
export function parseUrl(url, urlParams, queryString) {
  if (url.indexOf(":") === -1) return url;
  if (typeof urlParams !== "object") urlParams = {};
  if (typeof queryString !== "object") queryString = {};

  Object.keys(urlParams).forEach(function (key) {
    if (url.indexOf(key) !== -1) {
      url = url.replace(":" + key, encodeURI(urlParams[key]));
    } // END if
  }); // END ObjKeys

  Object.keys(queryString).forEach(function (key) {
    const value = encodeURI(queryString[key]);
    key = encodeURI(key);
    if (url.indexOf(key) === -1) {
      if (url.indexOf("?") === -1) {
        if (!!value) url = `${url}?${key}=${value}`;
        else url = `${url}?${key}`;
      } else {
        if (!!value) url = `${url}&${key}=${value}`;
        else url = `${url}?${key}`;
      } // END if
    } else {
      url = `${url}?${key}=${value}`;
    } // END if
  }); // END ObjKeys

  return url;
} // END parseUrl

// invoice.issue_date = new Date(Date.parse(get(invoice, "issue_date"))).toLocaleDateString();
export function getDate(ts, def) {
  if (!ts && def) return def;
  if (!ts || ts === 0) return "No disponible";

  let tsMil = /^([0-9]{13})$/.test(ts),
    tsSec = /^([0-9]{10})$/.test(ts),
    nodeDate = /^([0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}Z)$/.test(
      ts
    );

  if (tsSec) ts = parseInt(ts * 1000);
  else if (tsMil) ts = parseInt(ts);
  else if (nodeDate) ts = new Date(ts).getTime();
  else ts = null;

  // if (!ts) throw new Error('Input must be a valid timestamp (Seconds or miliseconds) or nodejs date');

  let meses = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ],
    date = new Date(ts),
    dia = date.getUTCDate(),
    mes = date.getUTCMonth(),
    yyy = date.getUTCFullYear();

  return `${dia}/${meses[mes]}/${yyy}`;
} // END getDate

export function getTimeHour(ts, def) {
  if (!ts) return "Sin fecha";

  let tsMil = /^([0-9]{13})$/.test(ts),
    tsSec = /^([0-9]{10})$/.test(ts),
    nodeDate = /^([0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}Z)$/.test(
      ts
    );

  if (tsSec) ts = parseInt(ts * 1000);
  else if (tsMil) ts = parseInt(ts);
  else if (nodeDate) ts = new Date(ts).getTime();
  else ts = null;

  if (!ts && def) return def;
  if (!ts) return null;

  let date = new Date(ts),
    hrs = date.getUTCHours(),
    // min = date.getMinutes(),
    min = String(date.getUTCMinutes()).padStart(2, '0'),
    sec = String(date.getUTCSeconds()).padStart(2, '0');

  return `${hrs}:${min}:${sec}`;
} // END getTimeHour

// ::TODO:: Implement more currencies
export function formatMoney(n, cur, decimal = 2) {
  let money = null;
  if (isNaN(parseFloat(n))) return "...";
  if (!cur) cur = "MXN";
  if (!money) money = "$";
  return `${money}${parseFloat(n)
    .toFixed(decimal)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,")} ${cur}`;
} // END formatMoney

export function formatMoneyNoCurrency(n) {
  let money = null;
  if (isNaN(parseFloat(n))) return "...";
  if (!money) money = "$";
  return `${money}${parseFloat(n)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
} // END formatMoney

export function formatNumber(n, decimal = 0) {
  if (isNaN(parseFloat(n))) return "0";
  return parseFloat(n).toFixed(decimal).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
} // END formatMoney



export function cleanNumber(number) {
  if (typeof number === "string") {
    number = number
      // Remove special characters
      .replace(/\,/g, "")
      .replace(/\$/g, "")
      // Remove all white space
      .replace(/\s/g, "")
      .replace(/^\s+|\s+$|\s+(?=\s)/g, "");
  }

  return parseFloat(number);
} // END cleanNumber

export function transformDataTables(string) {
  if (
    typeof string === "string" &&
    (string.includes("$") || string.includes("MXN"))
  ) {
    return cleanNumber(string);
  } else if (typeof string === "object") {
    return get(string, "props.data");
  } else if (string.includes("/")) {
    const meses = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ];
    let date = string.split("/");

    date[1] = meses.indexOf(date[1]) + 1;
    date = date.reverse().join("-");

    return moment(date).format("YYYYMMDD");
  } else {
    return string;
  }
}

export function splitAndClean(str) {
  return String(str)
    .split(",")
    .map((item) => item.trim());
} // END splitAndClean

/* ROWS */
export function invoicesRows(numberOfRows) {
  let rows = [];
  for (let i = 1; i < numberOfRows + 1; i++) {
    rows.push({
      id: <Link to={`/app/invoice/${i}`}>{i}</Link>,
      first: ["Maria", "Bobby  ", "Alexander"][Math.floor(Math.random() * 3)],
      date: getRandomDate(new Date(2002, 3, 1), new Date(1954, 3, 1)),
      dueDate: getRandomDate(new Date(2002, 3, 1), new Date(1954, 3, 1)),
      status: ["Por Pagar", "Pagado  ", "Cancelada"][
        Math.floor(Math.random() * 3)
      ],
      total: Math.min(10000, Math.round(Math.random() * 30) + 1000),
      action: ["Reenviar", "Archicar", "Compartir"][
        Math.floor(Math.random() * 3)
      ],
    }); // END push
  } // END of

  return rows;
} // invoicesRows

export function paymentsRows(numberOfRows) {
  let rows = [];
  for (let i = 1; i < numberOfRows + 1; i++) {
    rows.push({
      first: [
        "Chris Sanford",
        "Jovani Tate",
        "Gabrielle Francis",
        "Maeve Tran",
        "April Mata",
        "Miya Banks",
        "Cash Graves",
        "Amir Oconnor",
        "Chris Sanford",
        "Jovani Tate",
        "Gabrielle Francis",
        "Maeve Tran",
        "April Mata",
        "Miya Banks",
        "Cash Graves",
        "Amir Oconnor",
      ][Math.floor(Math.random() * 3)],
      total: `$${Math.floor(Math.random() * 99999) + 1000}.00`,
      date: getRandomDate(new Date(2002, 3, 1), new Date(1954, 3, 1)),
      method: [
        "01/Efectivo",
        "02/Cheque nominativo",
        "03/Transferencia de fondos",
        "04/Tarjetas de crédito",
        "05/Monederos electrónicos",
        "06/Dinero electrónico",
        "07/Tarjetas digitales",
        "08/Vales de despensa",
        "28/Tarjeta de débito",
        "29/Tarjeta de servicios",
        "99/Otros",
      ][Math.floor(Math.random() * 3)],
    }); // END push
  } // END of

  return rows;
} // paymentsRows

export function customerRows(numberOfRows) {
  let rows = [];
  for (let i = 1; i < numberOfRows + 1; i++) {
    rows.push({
      id: <Link to={`/app/customer/${i}`}>{i}</Link>,
      first: ["Maria", "Bobby  ", "Alexander"][Math.floor(Math.random() * 3)],
      last: ["Morisson", "Brown  ", "Medinberg"][Math.floor(Math.random() * 3)],
      user: ["@dragon", "@hamster", "@cat"][Math.floor(Math.random() * 3)],
      age: Math.min(100, Math.round(Math.random() * 30) + 20),
      date: getRandomDate(new Date(2002, 3, 1), new Date(1954, 3, 1)),
      location: ["Melbourne", "Tokio", "Moscow", "Rome"][
        Math.floor(Math.random() * 4)
      ],
      work: ["Nova Soft", "Dog Shop", "Aspirity", "Business Bro", "Starlight"][
        Math.floor(Math.random() * 5)
      ],
    }); // END push
  } // END of

  return rows;
} // customerRows

/* Active tabs */
export function filterInvoices(url, tab, page) {
  let parsedUrl = null;
  switch (parseInt(tab)) {
    case 1:
      parsedUrl = url;
      break;

    case 2:
      parsedUrl = `${url}?filter=paid`;
      break;

    case 3:
      parsedUrl = `${url}?filter=late_payment`;
      break;

    case 4:
      parsedUrl = `${url}?filter=uncollectable`;
      break;

    default:
      parsedUrl = url;
      break;
  } // END switch

  return applyPage(parsedUrl, page);
} // NED filterInvoices

export function filterContracts(url, tab, page) {
  let parsedUrl = null;
  switch (parseInt(tab)) {
    case 1:
      parsedUrl = `${url}?filter=active`;
      break;

    case 2:
      parsedUrl = `${url}?filter=inactive`;
      break;

    case 3:
      parsedUrl = `${url}?filter=no_ended`;
      break;

    default:
      parsedUrl = url;
      break;
  } // END switch

  return applyPage(parsedUrl, page);
} // NED filterContracts

export function filterPayments(tab) {
  switch (parseInt(tab)) {
    case 1:
      return;
      break;

    case 2:
      return 2;
      break;

    case 3:
      return 1;
      break;

    case 4:
      return 3;
      break;

    default:
      return;
      break;
  } // END switch
} // NED filterPayments

export function filterCustomers(tab) {
  switch (parseInt(tab)) {
    case 1:
      return;

    case 2:
      return 0;

    case 3:
      return true;

    default:
      return 1;
  } // END switch
} // NED filterInvoice

export function validations(type, data) {
  // TODO: Homologar función con isGodd, revisar si hay diferencias ya que se usa de manera indistinta y al parecer hacen lo mismo
  const emailRe = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\S*$/,
    recoveryRe = /^[0-9a-zA-Z\%\$\.\/]{60}$/g,
    tokenRe = /^[0-9a-zA-Z\%\$\.\/-]{200,500}/g,
    confTokenRe = /^[0-9a-zA-Z\%\$\.\/-]{30,50}/,
    nameRe = /^[\sa-zA-Z\u00E0-\u00FC\u00C0-\u00DC\u00C7 ']+$/,
    companyNameRe = /^[\sa-zA-Z0-9\u00E0-\u00FC\u00C0-\u00DC\u00C7\. ']+$/,
    uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/,
    zipRe = /(^\d{5}$)|(^\d{5}-\d{4}$)/,
    noSpacesRe = /^\S*$/,
    phoneNumberRe = /^[0-9]{10}$/g

  let result;
  if (!data) data = "";
  switch (type) {
    case "email":
      result = emailRe.test(data);
      return result;
    case "uuid":
      result = uuid.test(data);
      return result;
    case "password":
      return data.length > 5 ? true : false;

    case "confirmation":
      result = confTokenRe.test(data);
      return result;

    case "recovery":
      result = recoveryRe.test(data);
      return result;

    case "token":
      result = tokenRe.test(data);
      return result;

    case "zip":
      result = zipRe.test(data);
      return result;

    case "number":
      return !Number.isInteger(data);

    case "enterprise_name":
      if (data.length < 2) return false;
      result = companyNameRe.test(data);
      return result;

    case "name":
      if (data.length < 2) return false;
      result = nameRe.test(data);
      return result;

    case "noSpaces":
      result = noSpacesRe.test(data);
      return result;

    case "phoneNumber":
      result = phoneNumberRe.test(data)
      return result;

    default:
      console.error("Unknown validation");
      break;
  } // END switch
} // END validations

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1),
    vars = query.split("&");

  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) == variable)
      return decodeURIComponent(pair[1]);
  } // END for

  return null;
} // END getQueryVariable

// Promise helper for setState
// https://github.com/facebook/react/issues/2642#issuecomment-236531602
export function setStatePromise(that, newState, retVal) {
  return new Promise((resolve) =>
    that.setState(newState, (changedState) => resolve(retVal || changedState))
  );
} // END setStatePromise

export function booleanToNumber(bool) {
  return bool ? 1 : 0;
} // END booleanToNumber

export function numberToBoolean(num) {
  return parseInt(num) === 1 ? true : false;
} // END numberToBoolean

export function fixTitle(selector) {
  if (!selector) selector = '.react-grid-Row div[title*="[object Object]"]';
  var elements = document.querySelectorAll(selector);
  elements.forEach((e) => (e.title = "Ir al detalle"));
  return Promise.resolve(selector);
} // END fixTitle

export class Consequence {
  constructor({
    dispatch,
    payload: { data, retVal },
    eventTypes: { success, error },
    validator,
  }) {
    this.dispatch = dispatch;
    this.data = data;
    this.retVal = retVal;
    this.success = success;
    this.error = error;
    this.validator = validator;
  } // END constructor

  validateSelf() {
    if (typeof this.dispatch !== "function")
      return new Error("Consequence: you must provive a dispatch function");
    if (typeof this.success !== "string")
      return new Error(
        'Consequence: a valid success evnet name must be provided via "{ eventTypes: success }"'
      );
    if (typeof this.error !== "string")
      return new Error(
        'Consequence: a valid error evnet name must be provided via "{ eventTypes: error }"'
      );
  } // END validateSelf

  then(resolve, reject) {
    if (typeof resolve !== "function") resolve = () => { };
    if (typeof reject !== "function") reject = () => { };

    let error = this.validateSelf();
    if (error instanceof Error) return reject(error);

    let result =
      typeof validator === "function" ? this.validator(this.data) : this.data,
      action = { type: this.success };

    if (this.isError(result)) return reject(result);
    else if (!!result) Object.assign(action, { payload: result });

    if (!!action.type) this.dispatch(action);

    let resolveWith = !!this.retVal ? this.retVal : result;
    resolve(resolveWith);
  } // END thenable

  isError(value) {
    if (!value) return false;
    if (value instanceof Error) {
      let action = { type: this.error };
      if (value.hasOwnProperty("message"))
        Object.assign(action, { payload: value.message });

      this.dispatch(action);
      return true;
    } // END if
  } // END  isError
} // END Consequence

/* HELPER FUNCTIONS */
function applyPage(str, n) {
  let qsChar = "?";
  if (str.indexOf("?") !== -1) qsChar = "&";
  if (!isNaN(parseInt(n))) return str + `${qsChar}page=${n}`;
  return str;
} // END applyPage

/* VALIDATION cuenta CLABE */
const ponderacion = [3, 7, 1];
const generateVerifiyingDigit = (account_number) => {
  let i = 0,
    sum = 0,
    d,
    verifiyingDigit;
  account_number.split("").forEach((digit) => {
    d = (parseInt(digit) * ponderacion[i % 3]) % 10;
    sum = sum + d;
    i++;
  });
  sum = sum % 10;
  sum = 10 - sum;
  verifiyingDigit = sum % 10;
  return verifiyingDigit;
}; // END generateVerifiyingDigit

export const isValidAccountNumber = (account_number) => {
  let isValidAccountNumber = false;
  if (/^\d{18}$/.test(account_number)) {
    let subClabe = account_number.substring(0, 17),
      verifiyingDigit = generateVerifiyingDigit(subClabe);
    isValidAccountNumber =
      account_number.endsWith(verifiyingDigit) &&
      account_number == subClabe + verifiyingDigit;
  }
  return isValidAccountNumber;
}; // END isValidAccountNumber

/* Remote subiter helper */
export function remoteSubmiterHelper(form, submitCallback) {
  if (typeof submitCallback === "function") return submitCallback(form);
  else console.warn("Try submitting again");
} // END remoteSubmiterHelper

// ::TODO:: return null will render placeholder
/* Table parsing helper, checks page is a valid array of objects */
export function parseTableHelper(page, itFn) {
  // Validate Incoming
  if (!has(page, "[0].uuid")) return [{}];
  const iterable = cloneDeep(page);
  if (!hasIn(iterable, "map")) return [{}];

  // Parse table Arr
  const retVal = iterable.map(itFn);
  if (isArray(retVal)) return retVal;
  else return [{}];
} // END parseTableHelper
export function parseTableCreditNoteHelper(page, itFn) {
  // Validate Incoming
  
  const iterable = cloneDeep(page);
  // Parse table Arr
  const retVal = iterable.map(itFn);
  if (isArray(retVal)) return retVal;
  else return [{}];
} // END parseTableHelper

export function parseTableHelperProducts(page, itFn) {
  // Validate Incoming
  if (!has(page, "[0].uuid")) return [];
  const iterable = cloneDeep(page);
  if (!hasIn(iterable, "map")) return [];

  // Parse table Arr
  const retVal = iterable.map(itFn);
  if (isArray(retVal)) return retVal;
  else return [];
} // END parseTableHelper

/* Simple random helper */
export function ranStr() {
  return Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, "")
    .substr(0, 5);
} // END ranStr

/**
* Carga script de form asincrona
* @param  {string} url Librería que se quiere cargar
* @return {Object}     Objeto promesa
*/
export function asyncLoadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");

    script.src = url;
    script.type = "text/javascript";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Script failed to load: ${url}`));

    document.body.appendChild(script);
  })
    .catch(error => {
      throw error;
    })
} // END asyncLoadScript

/* Unit helper */
export function getUnit(unit_id) {
  switch (parseInt(unit_id)) {
    case 1:
      return "Pieza";

    case 2:
      return "Elemento";

    case 3:
      return "Unidad de Servicio";

    case 4:
      return "Actividad";

    case 5:
      return "Kilogramo";

    case 6:
      return "Trabajo";

    case 7:
      return "Tarifa";

    case 8:
      return "Metro";

    case 9:
      return "Paquete a granel";

    case 10:
      return "Caja Base";

    case 11:
      return "Kit";

    case 12:
      return "Conjunto";

    case 13:
      return "Litro";

    case 14:
      return "Caja";

    case 15:
      return "Mes";

    case 16:
      return "Hora";

    case 17:
      return "Metro cuadrado";

    case 18:
      return "Equipos";

    case 19:
      return "Miligramo";

    case 20:
      return "Paquete";

    case 21:
      return "Kit";

    case 22:
      return "Variedad";

    case 23:
      return "Gramo";

    case 24:
      return "Par";

    case 25:
      return "Docenas de piezas";

    case 26:
      return "Unidad";

    case 27:
      return "Día";

    case 28:
      return "Lote";

    case 29:
      return "Grupos";

    case 30:
      return "Mililitro";

    case 31:
      return "Viaje";

    case 30:
      return "Mililitro";

    case 31:
      return "Viaje";

    case 32:
      return "Mensual";

    case 33:
      return "Sin descripción";
    case 34:
      return "Año";

    case 35:
      return "Metro Lineal";

    case 36:
      return "Kilo bruto";

    case 37:
      return "Uno";

    case 38:
      return "Botella cilíndrica protegida";

    case 39:
      return "Mutuamente definido";

    case 40:
      return "Empaque a granel";

    case 41:
      return "Unidad de tiempo y espacio";

    default:
      return "No disponible";
  } // END switch
} // END getUnit

/* ErrorSubscription helper */
export function parseErrorSubscription(code) {
  switch (parseInt(code)) {
    case 2001:
      return "La cuenta de banco con esta CLABE ya se encuentra registrada en el cliente.";

    case 2002:
      return "La tarjeta con este número ya se encuentra registrada en el cliente.";

    case 2003:
      return "El cliente con este identificador externo (External ID) ya existe.";

    case 2004:
      return "El dígito verificador del número de tarjeta es inválido de acuerdo al algoritmo Luhn.";

    case 2005:
      return "La fecha de expiración de la tarjeta es anterior a la fecha actual.";

    case 2006:
      return "El código de seguridad de la tarjeta (CVV2) no fue proporcionado.";

    case 2007:
      return "El número de tarjeta es de prueba, solamente puede usarse en Sandbox.";

    case 2008:
      return "La tarjeta no es valida para puntos Santander.";

    case 2009:
      return "El código de seguridad de la tarjeta (CVV2) es inválido.";

    case 2010:
      return "Autenticación 3D Secure fallida.";

    case 2011:
      return "Tipo de tarjeta no soportada.";

    case 703001:
      return "La tarjeta fue rechazada.";

    case 703002:
      return "La tarjeta ha expirado.";

    case 703003:
      return "La tarjeta no tiene fondos suficientes.";

    case 703004:
      return "La tarjeta ha sido identificada como una tarjeta robada.";

    case 703005:
      return "La tarjeta ha sido rechazada por el sistema antifraudes.";

    case 703006:
      return "El 'token_id' ha expirado.";

    case 3005:
      return "La tarjeta ha sido rechazada por el sistema antifraudes.";

    case 1001:
      return "Los campos no tienen el formato correcto, o la petición no tiene campos que son requeridos.";

    default:
      return "Ocurrió un error, inténtalo más tarde.";
  } // END switch
} // END parseErrorSubscription

/* RenameKeys helper */
export function renameKeys(obj, newKeys) {
  const keyValues = Object.keys(obj).map((key) => {
    const newKey = newKeys[key] || key;
    return { [newKey]: obj[key] };
  });
  return Object.assign({}, ...keyValues);
} // EDN renameKeys

/*parseNumberToDaysOfTheWeek*/
export function parseNumberToDaysOfTheWeek(number) {
  switch (number) {
    case 1:
      return "Domingo";

    case 2:
      return "Lunes";

    case 3:
      return "Martes";

    case 4:
      return "Miércoles";

    case 5:
      return "Jueves";

    case 6:
      return "Viernes";

    case 7:
      return "Sábado";

    default:
      return "Día inválido";
  }
} // parseNumberToDaysOfTheWeek

/*Segment track view*/
export function segmentTrackPageView(page, teamUuid, params = {}) {
  let contextObject = {
    companyId: teamUuid,
    location: window.location.pathname,
    context: { groupId: teamUuid },
  }; // END contextObject

  if (typeof window.analytics !== "object") return;

  if (teamUuid) window.analytics.page(page, { ...contextObject, ...params });
  else window.analytics.page(page);
} // END segmentTrackPageView

export function segmentViewCustomerInvoicesHelper(filter, created) {
  let firstFilter, date;

  switch (filter) {
    case "late_payment":
      firstFilter = "overdue";
      break;

    case "current":
      firstFilter = "due";
      break;

    case "unpaid":
      firstFilter = "unpaid";
      break;

    case "paid":
      firstFilter = "paid";
      break;

    case "all":
      firstFilter = "all";
      break;

    default:
      break;
  }

  switch (created) {
    case 30:
      date = "last 30 days";
      break;

    case 60:
      date = "last 60 days";
      break;

    case 0:
      date = "actual month";
      break;

    case -1:
      date = "last month";
      break;

    case "show":
      date = "other";
      break;

    default:
      break;
  }

  return { filter: firstFilter, date };
}

export function segmentTrackEvent(segmentEvent, teamUuid, params = {}) {
  let contextObject = {
    companyId: teamUuid,
    location: window.location.pathname,
    context: { groupId: teamUuid },
  }; // END contextObject

  if (typeof window.analytics !== "object") return;

  if (!teamUuid) return window.analytics.track(segmentEvent, params);
  return window.analytics.track(segmentEvent, { ...params, ...contextObject });
} // END segmentTrackEvent

export function parseSpecialCustomerCharacters(str) {
  if (!!str) {
    if (str.includes("&amp;")) return str.replace("&amp;", "&");
    return str;
  } // END if
} // END parseEspecialCustomerCharacters

export function isValidUUID(uuid) {
  return /^[0-9a-f]{8}\-[0-9a-f]{4}\-[1-5][0-9a-f]{3}\-[89ab][0-9a-f]{3}\-[0-9a-f]{12}$/i.test(
    uuid
  );
} // END isValidUUID

export function clabeFormatNumber(number) {
  let clabe = String(number);
  let lng = clabe.length;
  return `${clabe.substring(0, 3)} ${clabe.substring(3, 6)} ${clabe.substring(
    6,
    lng - 1
  )} ${clabe.substring(lng - 1, lng)}`;
} // END clabeFormatNumber

//TODO: Refactor this function in XC2022-6
export function thresholds(qty, max, reverseBar = null) {
  const pF = (qty, max) => (qty / max) * 100;
  const porcentageValue = pF(qty, max);

  let circular = 0,
    bar = 0,
    text = "...";

  // circular
  if (porcentageValue > 70 && !!reverseBar) {
    circular = "CircularProgressbar yellow";
    bar = "progress-wrap progress-wrap--big progress-wrap--yellow";
    text = "text-yellow";
  } else if (porcentageValue > 50) {
    circular = "CircularProgressbar green";
    bar = "progress-wrap progress-wrap--big progress-wrap--green";
    text = "text-green";
  } else if (porcentageValue <= 49 && porcentageValue > 20) {
    circular = !!reverseBar
      ? "CircularProgressbar green"
      : "CircularProgressbar yellow";
    bar = !!reverseBar
      ? "progress-wrap progress-wrap--big progress-wrap--green"
      : "progress-wrap progress-wrap--big progress-wrap--yellow";
    text = !!reverseBar ? "text-green" : "text-yellow";
  } else {
    circular = !!reverseBar
      ? "CircularProgressbar green"
      : "CircularProgressbar red";
    bar = !!reverseBar
      ? "progress-wrap progress-wrap--big progress-wrap--green"
      : "progress-wrap progress-wrap--big progress-wrap--red";
    text = !!reverseBar ? "text-green" : "text-red";
  } // END if

  return { circular, bar, text, porcentage: porcentageValue };
} // END thresholds

export function simpleId() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return "" + Math.random().toString(36).substr(2, 9).toUpperCase();
} // END simpleIdx

export function parseSubscription(description) {
  switch (description) {
    case "Suscripción Gratuita":
      return 1;

    case "Suscripción Basic (Mensual)":
      return 2;

    case "Suscripción Basic (Anual)":
      return 2;

    case "Suscripción Growth (Mensual)":
      return 3;

    case "Suscripción Growth (Anual)":
      return 3;

    case "Suscripción Pro (Mensual)":
      return 4;

    case "Suscripción Pro (Anual)":
      return 4;

    case "Suscripción Pro (Freemium)":
      return 4;

    default:
      return 1;
  }
} // END parseSubscription

export function parsePlanFromDescription(description) {
  if (!description) description = "";

  if (description.indexOf("Freemium") !== -1)
    // Suscripción  Pro (Freemium)
    return 4;
  else if (description.indexOf("Free") !== -1)
    // Suscripción Free
    return 1;
  else if (description.indexOf("Basic") !== -1)
    // Suscripción Basic (Anual)
    return 2;
  else if (description.indexOf("Growth") !== -1)
    // Suscripción Growth (Anual)
    return 3;
  else if (description.indexOf("Pro") !== -1)
    // Suscripción Pro (Anual)
    return 4;
  else if (description.indexOf("enterprise") !== -1)
    // Suscripción Enterprise
    return 5;

  console.warn("Bad plan description, falling back to 4");
  return 4;
} // END parsePlanFromDescription

// SOURCE: https://stackoverflow.com/a/33928558
// Copies a string to the clipboard. Must be called from within an
// event handler such as click. May return false if it failed, but
// this is not always possible. Browser support for Chrome 43+,
// Firefox 42+, Safari 10+, Edge and Internet Explorer 10+.
// Internet Explorer: The clipboard feature may be disabled by
// an administrator. By default a prompt is shown the first
// time the clipboard is used (per session).
export function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
} // END copyToClipboard

// SOURCE: https://stackoverflow.com/questions/7463658/how-to-trim-a-string-to-n-chars-in-javascript
export function trimByLength(str, length) {
  if (!str) str = "";
  return str.length > length ? str.substring(0, length) + "..." : str;
} // END trimByLength

//Payment Terms
export function paymentTerms(client) {
  let payment_term = get(client, "agreement.payment_term", "No Disponible");
  let text = "";

  if (payment_term === 0) {
    text = "Al contado";
  } else if (payment_term !== 0 && typeof payment_term === "number") {
    text = `${payment_term} días`;
  } else {
    text = payment_term;
  }

  return text;
} //END Payment Terms

export function encryptCard(card, key, env) {
  const simpleCrypto = new SimpleCrypto(key);
  const token = simpleCrypto.encrypt(JSON.stringify(card));
  const payload = { token };

  if (env != "production") {
    const decipherText = simpleCrypto.decrypt(token);
    console.warn("XXX key", key);
    console.warn("XXX decipherText", decipherText);
  } // END if

  return payload;
} // END encryptCard

export function sizeFiles(files) {
  let cont = 0;

  if (head(files)) {
    Array.from(files).forEach((file) => {
      if (parseInt(file.size / Math.pow(1024, 2)) > 10) cont += 1;
    });
    return cont;
  } // END if

  return;
}

export function validateRfc(rfc) {
  let re = /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/;

  return re.test(rfc);
} // END validateRfc

export function typeSidebard(type) {
  switch (type) {
    case "addPayment":
      return "agregar pago";

    case "create customer":
      return "agregar cliente";

    case "addCollectionReminder":
      return "agregar recordatorio";

    case "card":
      return "el cambio de tarjeta";

    case "invoicing":
      return "la edición de los datos de facturación";

    case "addProduct":
      return "agregar producto";

    default:
      return "";
  }
}

export function cutIdentifiers(string) {
  if (typeof string === "string" && string.length > 25) {
    return `${string.slice(0, 7)}...${string.slice(-7)}`;
  }
  return string;
}

export function checkoutStripe(stripePublickKey, sessionId) {
  const globalStripe = get(window, "Stripe");
  let stripe;

  if (globalStripe) {
    stripe = globalStripe(stripePublickKey);
    return stripe.redirectToCheckout({
      sessionId: sessionId,
    });
  } else {
    asyncLoadScript("https://js.stripe.com/v3/").then(() => {
      stripe = get(window, "Stripe")(stripePublickKey);
      return stripe.redirectToCheckout({
        sessionId: sessionId,
      });
    });
  }
} // END checkoutStripe

export function download(url) {
  if (!url) return;

  const isPdfFile = url.endsWith(".pdf");
  const isXml = url.endsWith(".xml");
  const isXls = url.endsWith(".xlsx");

  if (isPdfFile) {
    window.open(url);
  } else if (isXml || isXls) {
    let iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.style.visibility = "visible";
    document.body.append(iframe);

    iframe.contentDocument.write(
      `<form action="${url.replace(/\"/g, '"')}" method="GET"></form>`
    );
    iframe.contentDocument.forms[0].submit();

    setTimeout(() => iframe.remove(), 2000);
  }
} // END download

export function tooltipOxxoAmountMessage(total) {
  let message = "";
  if (total < MINIMUM_AMOUNT_TO_PAY)
    message =
      "El monto mínimo de pago es de $15.00 MXN.";
  if (total > MAXIMUN_AMOUNT_TO_PAY_OXXO)
    message =
      "El monto máximo de pago es de $10,000.00 MXN.";

  return message;
} // END tooltipOxxoAmountMessage

export function getProviderIntegrationStatus(providerIntegrations = []) {
  const integrationsDefaultStatus = {
    stp: "inactive",
    stripe: "inactive",
    conekta: "inactive",
    conektaGlobal: 'inactive',
    paymentInstruction: { status: "inactive", instructions: {} },
  };

  if (!Array.isArray(providerIntegrations)) return integrationsDefaultStatus;

  const stp = providerIntegrations.some(integration => get(integration, "name") === "stp");
  const stripe = providerIntegrations.some(integration => get(integration, "name") === "stripe");
  const conekta = providerIntegrations.find(integration => get(integration, "integration_id") === CONEKTA_INTEGRATION_ID || get(integration, "integration_id") === OXXO_INTEGRATION_ID);
  const paymentInstruction = providerIntegrations.find(integration => get(integration, "integration_id") === PAYMENT_INSTRUCTIONS_ID);
  const conektaGlobal = Number(get(conekta, 'attributes.is_global', 0))

  return {
    stp: stp ? INTEGRATION_IS_ACTIVE : get(integrationsDefaultStatus, "stp"),
    stripe: stripe ? INTEGRATION_IS_ACTIVE : get(integrationsDefaultStatus, "stripe"),
    conekta: conekta ? INTEGRATION_IS_ACTIVE : get(integrationsDefaultStatus, "conekta"),
    conektaGlobal: conektaGlobal ? INTEGRATION_IS_ACTIVE : get(integrationsDefaultStatus, "conektaGlobal"),
    paymentInstructions: {
      status: paymentInstruction
        ? INTEGRATION_IS_ACTIVE
        : get(integrationsDefaultStatus, "paymentInstruction.status"),
      instructions: providerIntegrations.find(
        (integration) => get(integration, "name") === "payment_instruction"
      ),
    },
    onlyInstructions: paymentInstruction && !stp && !stripe && !conekta,
    noOptionsToPay: !paymentInstruction && !stp && !stripe && !conekta,
    integrationsAndInstructions: {
      payment_instruction: paymentInstruction,
      instructions: get(paymentInstruction, "attributes.payment_bank_transfer"),
      stp,
      stripe,
      conekta,
    },
  };
} // END getProviderIntegrationStatus

export function cutDescription(string) {
  if (typeof string === "string" && string.length > CONCEPT_MAX_LENGTH) {
    return `${string.slice(0, CONCEPT_MAX_LENGTH)}`;
  }
  return string;
}

export function isCfdiCancelNeedAcceptance(cfdi) {
  const limitHoursBeforeAcceptance = 72;
  const limitDate = moment(get(cfdi, "attributes.cfdi_seal_date")).add(
    72,
    "hours"
  );
  if (moment.isMoment(limitDate)) {
    if (moment(limitDate).isBefore() && cleanNumber(get(cfdi, "total")) > 5000)
      return true;
    else return false;
  }

  return true;
} // END isCfdiCancelNeedAcceptance

export function isIncompleteClient(client) {
  if (!get(client, "email") || !get(client, "phone")) return true;
  else return false;
} // END isIncompleteClient

export function calculateExchangeAmount(amount, rate) {
  if (!rate) return cleanNumber(amount);
  return formatNumberTwoDecimals(amount / rate);
} // END calculateExchangeAmount

export function calculateAmountInMxn(amount, rate) {
  if (!rate) return cleanNumber(amount);
  return formatNumberTwoDecimals(amount * rate);
} // END calculateAmountInMxn

export function formatNumberTwoDecimals(number) {
  if (typeof number === "string") {
    number = Number(number);
  }

  return Math.round((number + Number.EPSILON) * 100) / 100;
} // END formatNumberTwoDecimals

export function isCustomPaymentCondition(paymentCondition = 0) {
  const defaultPaymentConditions = [0, 7, 15, 30, 45, 60, 90]; // 0 => al contado, 7,15,30,45,60,90 => days

  return !defaultPaymentConditions.includes(cleanNumber(paymentCondition));
} // END isCustomPaymentCondition

export function createUrlWhatsapp(text, phone) {
  !!phone ? (phone = `52${phone}`) : (phone = "");
  const whatsUrl = `https://wa.me/${phone}?text=${text}`;

  window.open(`${whatsUrl}`);
}

export function toFixed(number, decimals) {
  const x = Math.pow(10, Number(decimals) + 1);
  const parseNumber = (Number(number) + 1 / x).toFixed(decimals);

  return parseFloat(parseNumber);
}

export function twoDigits(theform) {
  var num = theform.original.value,
    rounded = theform.rounded;
  var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
  return (rounded.value = with2Decimals);
}

export function verifySubscription(subscription) {
  const plan_code = get(subscription, "product.plan_code");
  const trial = get(subscription, "is_trial");
  const notAvailable = [1];
  if (!notAvailable.includes(plan_code) || !!trial) return true;
  else if (notAvailable.includes(plan_code) || !trial) return false;
} //END verifySubscription

export function onlyNumbers(e) {
  return (e.target.value = get(e, "target.value").replace(/[^0-9]/g, ""));
} // END onlyNumbers

export function parseEmails(str) {
  const emails = /[ ,]+/.test(str) ? str.split(/[ ,]+/) : [str];

  return compact(emails);
} // END parseEmails

export function getCustomerName(customer) {
  if (typeof get(customer, "name") === "string" && get(customer, "name"))
    return parseSpecialCustomerCharacters(get(customer, "name"));
  if (
    typeof get(customer, "legal_name") === "string" &&
    get(customer, "legal_name")
  )
    return parseSpecialCustomerCharacters(get(customer, "legal_name"));

  return get(customer, "tax_profile", "Sin datos");
} // END getCustomerName

export function getContractCheckoutUtils(contract = {}, paymentCatalog) {
  const totalPayed =
    get(contract, "total_contract", 0) - get(contract, "balance_contract");
  const issuedInvoices = get(contract, "invoices", []);
  const dueInvoices = issuedInvoices.filter((invoice) => {
    const _paymentStatus = paymentCatalog.getStatus(
      get(invoice, "status_id"),
      get(invoice, "due_date")
    );
    return get(_paymentStatus, "value") === "Vencido";
  });
  const issuedInvoicesToPay = issuedInvoices.filter((invoice) => {
    const _paymentStatus = paymentCatalog.getStatus(
      get(invoice, "status_id"),
      get(invoice, "due_date")
    );
    return (
      get(_paymentStatus, "value") !== "Cancelada" &&
      get(_paymentStatus, "value") !== "Pagado"
    );
  });
  const totalIssuedInvoices = issuedInvoices.reduce(
    (accumulator, invoice) => accumulator + get(invoice, "total", 0),
    0
  );
  const isDue = !isEmpty(dueInvoices);
  const isAware = totalPayed === totalIssuedInvoices; // AL corriente

  return {
    issuedInvoices,
    dueInvoices,
    totalIssuedInvoices,
    isDue,
    isAware,
    totalPayed,
    issuedInvoicesToPay,
  };
} // END getContractCheckoutUtils

export function hideIntercomWidget() {
} // END hideIntercomWidget

/**
 * Funcion de descarga de archivos Xlsx
 * @param {object} data Buffer data
 * @param {string} name Nombre del archivo
 * @param {object} account Objeto de cuenta
 */

export function downloadXls(data, name, account) {  
  segmentTrackEvent(name === "clientes" ? "PC:Client List - Exported" : "Export Invoices", get(account, "team.uuid"));
  var blob = new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const a = window.document.createElement("a");
  a.href = window.URL.createObjectURL(blob, {
    type: "data:attachment/xlsx",
  });
  a.download = `${name}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
* Cierra sesión en Intercom llamando el método shutdown
*/
export function logOutIntercom() {
}

/**
* Bloquea las acciones de enviar recordatorio y agregar pago de facturas/notas de venta por status o por balance
* @param  {string} invoiceStatus Estatus de la factura/nota de venta
* @param  {number} balance       Balance de la factura/nota de venta
* @return {boolean}              True para bloquear la acción
*/
export function blockInvoiceActions(invoiceStatus, balance) {
  let blockAction = false;

  if (invoiceStatus === 'Pagado' || invoiceStatus === 'Cancelada' || balance === 0) {
    blockAction = true;
  }

  return blockAction;
}

/**
* Regresa una imagen aleatoria de un array dado
* @param {array} imagesArray Array de imágenes
*/
export function randomImage(imagesArray = []) {
  const randomIndex = Math.floor(Math.random() * imagesArray.length);

  return imagesArray[randomIndex]
}

/**
* Crea y abre la url de signup de P-Card con los datos enviados
* @param {Object} params Informacion necesaria para P-Card
*/
export function createUrlPcard({ name, email, source = 'Visa', medium = 'PorCobrar' }) {
  const codedData = btoa(`email=${email}&name=${name}`);
  const url = `https://app.p-card.com/signup?rt=${codedData}&utm_source=${source}&utm_medium=${medium}`;

  window.open(url, '_blank');
}

/**
* Realiza la conversion de los montos de centavos a unidades en una base sobre 100
* @param {number} price Precio o monto sobre el que se realizara la conversion
*/
export function centsToUnits(price) {
  return price / 100;
};

/**
* Dispara acciones de redux para restablecer datos al cerrar sesión
*/
export async function appLogout() {
  const { dispatch } = store;
  const { status } = get(store.getState(), 'admin', {});

  try {
    await axios.delete(LOGIN);
  } catch (_e) { void _e; } finally {
    if (status === 'active') dispatch(clearAdmin());
    dispatch(alertMobileNotification(false));
    dispatch(logOut());
    logOutIntercom();
  }
}

export function conceptIsBeerCode(productCode) {
  return productCode === '50202201';
}

export function conceptHasSpecificTax(taxes = [], tax) {
  const { code, amount } = tax;
  const hasTax = taxes.some(tax => {
    return get(tax, 'code') === code && get(tax, 'amount') === amount;
  })

  return hasTax;
}

/**
* Obtiene las características con las cuales se va a identificar al usuario en segment
* @param {Object} params {user, isSignup}. Información del usuario y booleano para indicar si es signup
* @return {Object} Características con las cuáles se va a identificar al usuario en segment
*/
export function getUserTraits({ user = {}, isSignup = false }) {
  const { rol_id, account_reference } = user;
  const phone = get(user, "team.profile.phone", "");
  let role = rol_id === 1 ? 'admin' : 'member';

  if (!account_reference) role = 'owner';
  const userTraits = {
    email: get(user, "email"),
    name: get(user, "name"),
    first_name: get(user, "name"),
    phone: typeof phone === "string" ? phone.replace(/\s/g, '') : "",
    role,
    company: get(user, "team.uuid"),
    ...IDENTIFYCONFIG
  };

  // if (role === "owner") {
  //   userTraits.company.name = get(user, "team.name");
  //   userTraits.company.plan_name = get(user, "subscription.description");
  //   userTraits.company.plan_is_trial = get(user, "subscription.is_trial");
  //   userTraits.company.plan_start_at = moment.unix(get(user, "subscription.start_date")).format("DD-MM-YYYY, HH:mm");
  //   userTraits.company.plan_expire_at = moment.unix(get(user, "subscription.end_date")).format("DD-MM-YYYY, HH:mm");
  // }

  if (isSignup && role === "owner") {
    userTraits.utm_source = get(user, "campaign.utm_source");
    userTraits.utm_medium = get(user, "campaign.utm_medium");
    userTraits.utm_content = get(user, "campaign.utm_content");
    userTraits.utm_term = get(user, "campaign.utm_term");
    userTraits.utm_campaign = get(user, "campaign.utm_campaign");
  }

  return userTraits;
}

/**
* Identifica al usuario en segment
* @param {Object} params {user, updateInformation, isSignup}. Información del usuario, booleano 
* indicando si se va actualizar información del usuario y booleano indicando si es signup
*/
export function segmentIdentifyUser({ user = {}, updateInformation = false, isSignup = false, payload = null }) {
  if (typeof window.analytics !== "object") return;

  const { uuid: accountUuid } = user;

  if (!updateInformation) {
    return window.analytics.identify(accountUuid);
  }

  const userTraits = payload || getUserTraits({
    user,
    isSignup
  })

  window.analytics.identify(accountUuid, userTraits);
}

/**
 * Agrupa al usuario a la empresa a la que pertenece
 * @param {Object} user Información del usuario
 */
export function segmentGroup(user = {}) {
  if (typeof window.analytics !== "object") return;

  window.analytics.group(get(user, "team.uuid"), {
    companyId: get(user, "team.uuid"),
    email: get(user, "email"),
    name: get(user, "name"),
    plan_is_trial: get(user, "subscription.is_trial"),
    plan_start_at: moment.unix(get(user, "subscription.start_date")).format("DD-MM-YYYY, HH:mm"),
    plan_expire_at: moment.unix(get(user, "subscription.end_date")).format("DD-MM-YYYY, HH:mm"),
    utm_source: get(user, "campaign.utm_source"),
    utm_medium: get(user, "campaign.utm_medium"),
    utm_content: get(user, "campaign.utm_content"),
    utm_term: get(user, "campaign.utm_term"),
    utm_campaign: get(user, "campaign.utm_campaign"),
    ...IDENTIFYCONFIG
  });
}

/**
* Actualiza el widget de zendesk
* @param {string} property Propiedad a actualizar
* @param {Object} payload Parámetros correspondientes a la actualización
*/
export function updateZendeskWidget(property, payload) {
  if (!window.zE) return;

  // NOTE: Documentación: https://developer.zendesk.com/api-reference/widget/core/#updatesettings
  window.zE("webWidget", "updateSettings", {
    webWidget: {
      [property]: payload
    }
  })
}

/**
* Envía información a google anlytics a través de eventos
* @param {string} eventName Nombre del evento
* @param {Object} payload Parámetros correspondientes al evento
*/
export function sendDataToAnalytics(eventName, properties = {}) {
  // if (!window.gtag) return;

  // window.gtag('event', eventName, properties);

}


/**
 * Trunca un número con una catidad definida de decimales sin redondear
 * @param {number} number Número a truncar
 * @param {number} digits Cantidad de digitos decimales
 * @return {number} Número truncado a una cantidad definida de decimales sin redondear
 */
export const decimalTruncate = (number, digits = 2) => {
    return Number((Math.floor(number * Math.pow(10, digits)) / Math.pow(10, digits)).toFixed(digits));
};

/**
* Abre el widget de zendesk
*/
export function openZendeskWidget() {
  if (!window.zE) return;
  
  window.zE('webWidget', 'open')
}

/**
* Oculta el widget de zendesk
*/
export function hideZendeskWidget() {
  if (!window.zE) return;
  
  window.zE('webWidget', 'hide')
}

/**
* Crea y abre la url de signup de P-Card con los datos enviados
* @param {string} uuid Payment intent uuid
*/
export function redirectCheckoutDigitalPayments(uuid) {
  // [H-025] URL de checkout obtenida de variable de entorno — evita exponer
  // URLs de ambientes internos (dev/stg) en el bundle de producción.
  const checkoutUrl = process.env.REACT_APP_CHECKOUT_URL || 'https://checkout.yaydoo.com/es/c/';
  const url = `${checkoutUrl}${uuid}`;

  window.location.href = url;
}


export function getCfdiUsageOptions({customerRfc, customerTaxRegime, cfdiSealVersion}, onlyPhysical=false) {
  const cfdiUsageMoralPersonByCfdiVersion = {
    [CFDI_THREE_VERSION]: moral_person_v3,
    [CFDI_FOUR_VERSION]: moral_person_v4
  };
  const cfdiUsagePhysicalPersonByCfdiVersion = {
    [CFDI_THREE_VERSION]: physical_person_v3,
    [CFDI_FOUR_VERSION]: physical_person_v4
  };
  let options = cfdiUsageMoralPersonByCfdiVersion[cfdiSealVersion];

  if (customerRfc && isPhysicalPerson(customerRfc)) {
    options = cfdiUsagePhysicalPersonByCfdiVersion[cfdiSealVersion];
  }

  if (customerTaxRegime && cfdiSealVersion === CFDI_FOUR_VERSION) {
    const cfdiUsageByTaxRegime = VALID_CFDI_USAGE_BY_TAX_REGIME[customerTaxRegime];
    const validOptionsByTaxRegime = options.filter(option => cfdiUsageByTaxRegime.includes(option.value));
    options = validOptionsByTaxRegime;
  }

  if (customerRfc && GENERIC_TAX_PROFILES.includes(customerRfc) && cfdiSealVersion === CFDI_FOUR_VERSION) {
    const withoutTaxEffectsOption = "S01";
    options = cfdiUsagePhysicalPersonByCfdiVersion[cfdiSealVersion].filter(option => option.value === withoutTaxEffectsOption);
  }

  if(onlyPhysical){
    options = cfdiUsagePhysicalPersonByCfdiVersion[cfdiSealVersion];
  }

  return options;
}

/**
 * roudPercentages - Function rounds percentages that sums 100%
 * @param {object} pers Object with all percentage fractions { ["fraction"]: value, ... }
 * @return {object} Same pers object with rounded persentaje vaules
 * 
 * CONSIDERATIONS:
 * If the sum of all values before rounded is less than 100, returns the same object with
 * no changes due to corrupted percentage fractions
 */

export function roudPercentages(pers){
  let arrayPers, rest, roundedPers = {}
  const sumPers = (arrayPers) => {return arrayPers.map(x => x.value).reduce( (a, b) => a + b)}
  arrayPers = Object.entries(pers).map(([key, value]) => {return {key, value}})
  if(parseInt(parseFloat(sumPers(arrayPers)).toFixed(0)) != 100){
    return pers
  }
  arrayPers.sort((a, b) => (b.value - Math.floor(b.value)) - (a.value - Math.floor(a.value)))
  arrayPers.forEach( item => item.value = Math.floor(item.value))
  rest = Math.abs( 100 - arrayPers.map(x => x.value).reduce( (a, b) => a + b))
  if(rest > arrayPers.length){
    return pers
  }
  for(let index in arrayPers){
    if(index < rest) arrayPers[index].value++
    roundedPers[arrayPers[index].key] = arrayPers[index].value
  }
  return roundedPers
}

/**
 * getProdictIdFromIndentifier - Returns product_id from indentifier
 * @param {string} identifier Identifier
 * @returns {string} prodict_id
 */

export function getProdictIdFromIndentifier(identifier){
  let product_id = '',
      items = identifier.split('-')
  if(items.length >= 2){
    product_id = items[1]
  }
  return product_id
}


export function getPropsById(prop, id) {
  const products = {
    ["201"]: {keyword: 'Movilidad', prod_short_name: 'Movilidad', sol_short_name: 'Auto',     prod_name: 'AUTO SEGURO FACIL',          sol_name: 'Movilidad' },
    ["202"]: {keyword: 'Movilidad', prod_short_name: 'Movilidad', sol_short_name: 'Auto',     prod_name: 'CAMIONES',                   sol_name: 'Movilidad' },
    ["205"]: {keyword: 'Movilidad', prod_short_name: 'Movilidad', sol_short_name: 'Auto',     prod_name: 'MOTOCICLETAS',               sol_name: 'Movilidad' },
    ["211"]: {keyword: 'Movilidad', prod_short_name: 'Movilidad', sol_short_name: 'Auto',     prod_name: 'AUTOS',                      sol_name: 'Movilidad' },
    ["204"]: {keyword: 'Movilidad', prod_short_name: 'Movilidad', sol_short_name: 'Auto',     prod_name: 'AUTOBUSES',                  sol_name: 'Movilidad' },
    ["203"]: {keyword: 'Movilidad', prod_short_name: 'Movilidad', sol_short_name: 'Auto',     prod_name: 'AUTOS TURISTAS',             sol_name: 'Movilidad' },
    ["601"]: {keyword: 'API',       prod_short_name: 'API',       sol_short_name: 'Beneficios',       prod_name: 'ACCIDENTES PERSONALES INDIVIDUAL/FAMILIAR', sol_name: 'Beneficios' },
    ["605"]: {keyword: 'APC',       prod_short_name: 'APG',       sol_short_name: 'Beneficios',       prod_name: 'ACCIDENTES PERSONALES GRUPO',               sol_name: 'Beneficios' },
    ["606"]: {keyword: 'AlaAzul',   prod_short_name: 'AA',        sol_short_name: 'GMI',      prod_name: 'GASTOS MEDICOS MAYORES INDIVIDUAL/FAMILIAR',        sol_name: 'Gastos Médicos Individuales' },
    ["607"]: {keyword: 'GastosMedicos', prod_short_name: 'GMG',   sol_short_name: 'Beneficios',       prod_name: 'GASTOS MEDICOS MAYORES GRUPO',              sol_name: 'Beneficios' },
    ["901"]: {keyword: 'PlanVive',  prod_short_name: 'VI',        sol_short_name: 'Beneficios',       prod_name: 'VIDA INDIVIDUAL',    sol_name: 'Beneficios' },
    ["902"]: {keyword: 'VidaGrupo', prod_short_name: 'VG',        sol_short_name: 'Beneficios',       prod_name: 'VIDA GRUPO',         sol_name: 'Beneficios' },
    ["907"]: {keyword: '', prod_short_name: 'GF',           sol_short_name: 'Beneficios',     prod_name: 'GASTOS FUNERARIOS',          sol_name: 'Beneficios' },
    ["101"]: {keyword: '', prod_short_name: 'Incendio',     sol_short_name: 'Daños',          prod_name: 'INCENDIO',                   sol_name: 'Daños' },
    ["301"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Transporte',     prod_name: 'TRANSPORTES',                sol_name: 'Daños' },
    ["302"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Cascos',         prod_name: 'CASCOS MARITIMOS',           sol_name: 'Daños' },
    ["400"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Eq. Electrónico',   prod_name: 'EQUIPO ELECTRONICO',      sol_name: 'Daños' },
    ["403"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Eq. Contratista',   prod_name: 'EQUIPO DE CONTRATISTAS',  sol_name: 'Daños' },
    ["405"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Rotura Maquinaria', prod_name: 'ROTURA DE MAQUINARIA',    sol_name: 'Daños' },
    ["411"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Obra civil',        prod_name: 'OBRA CIVIL',              sol_name: 'Daños' },
    ["420"]: {keyword: 'Hogar',     prod_short_name: 'Hogar',     sol_short_name: 'Hogar',    prod_name: 'MULTIPLE FAMILIAR 7 HOGAR',  sol_name: 'Daños' },
    ["430"]: {keyword: 'PES',       prod_short_name: 'PES',       sol_short_name: 'Empresa',  prod_name: 'MULTIPLE EMPRESARIAL',       sol_name: 'Daños' },
    ["501"]: {keyword: 'RespCivil', prod_short_name: 'Daños',     sol_short_name: 'RC',       prod_name: 'RESPONSABILIDAD CIVIL',      sol_name: 'Daños' },
    ["503"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'RC',             prod_name: 'RESPONSABILIDAD CIVIL VIAJERO', sol_name: 'Daños' },
    ["421"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Creditos',       prod_name: 'PROTEGE CREDITOS',           sol_name: 'Daños' },
    ["402"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Ob. Personales', prod_name: 'OBJETOS PERSONALES',         sol_name: 'Daños' },
    ["407"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Montaje',        prod_name: 'MONTAJE DE MAQUINARIA',      sol_name: 'Daños' },
    ["409"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Valores',        prod_name: 'DINERO Y VALORES',           sol_name: 'Daños' },
    ["413"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Obra Civil',     prod_name: 'OBRA CIVIL TERMINADA',       sol_name: 'Daños' },
    ["702"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Agricola',       prod_name: 'SEGURO AGRICOLA',            sol_name: 'Daños' },
    ["105"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Terremoto',   prod_name: 'TERREMOTO Y ERUPCIÓN VOLCÁNICA', sol_name: 'Daños' },
    ["206"]: {keyword: '', prod_short_name: 'Movilidad',    sol_short_name: 'Auto',        prod_name: 'SUVA',                           sol_name: 'Movilidad' },
    ["210"]: {keyword: '', prod_short_name: 'Movilidad',    sol_short_name: 'Auto',        prod_name: 'PRUEBAS DE AUTOS',               sol_name: 'Movilidad' },
    ["220"]: {keyword: '', prod_short_name: 'Movilidad',    sol_short_name: 'Auto',        prod_name: 'TAXIS',                          sol_name: 'Movilidad' },
    ["303"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Transportes', prod_name: 'TRANSPORTES DE CASCOS AVIACIÓN', sol_name: 'Daños' },
    ["401"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Cristales',   prod_name: 'ROTURA DE CRISTALES',            sol_name: 'Daños' },
    ["404"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Mercancias',  prod_name: 'ROBO DE MERCANCÍAS',             sol_name: 'Daños' },
    ["406"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Calderas',    prod_name: 'CALDERAS',                       sol_name: 'Daños' },
    ["410"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Anuncios',    prod_name: 'ANUNCIOS LUMINOSOS',             sol_name: 'Daños' },
    ["412"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Premios',     prod_name: 'PREMIOS',                        sol_name: 'Daños' },
    ["422"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Hogar',       prod_name: 'MÚLTIPLE FAMILIAR',              sol_name: 'Daños' },
    ["431"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Créditos',    prod_name: 'PROTEGE CRÉDITOS',               sol_name: 'Daños' },
    ["502"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'RC',          prod_name: 'RESPONSABILIDAD CIVIL FAMILIAR', sol_name: 'Daños' },
    ["602"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'ACC. PERSONALES ESCOLAR',        sol_name: 'Beneficios' },
    ["608"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'GASTOS MÉDICOS COLECTIVO',       sol_name: 'Beneficios' },
    ["610"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'PROTEGE FAMILIAR IND./FAM.',     sol_name: 'Beneficios' },
    ["701"]: {keyword: '', prod_short_name: 'Daños',        sol_short_name: 'Caballos',    prod_name: 'CABALLOS',                       sol_name: 'Daños' },
    ["801"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'VIDA PRUEBA',                    sol_name: 'Beneficios' },
    ["810"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'VIDA INDIV. MICROSEGURO 1 AÑO',  sol_name: 'Beneficios' },
    ["903"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'VIDA COLECTIVO',                 sol_name: 'Beneficios' },
    ["905"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'VIDA GRUPO DOTAL',               sol_name: 'Beneficios' },
    ["908"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'VIDA GRUPO (SSIT, SSC)',         sol_name: 'Beneficios' },
    ["909"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'CARTA DE COBERTURA',             sol_name: 'Beneficios' },
    ["931"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'VIDA INDIVIDUAL SURA',           sol_name: 'Beneficios' },
    ["990"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'ASISTENCIA HOGAR',               sol_name: 'Beneficios' },
    ["998"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'DAÑOS GASTOS FUNERARIOS',        sol_name: 'Beneficios' },
    ["999"]: {keyword: '', prod_short_name: 'Beneficios',   sol_short_name: 'Beneficios',  prod_name: 'TODOS LOS RAMOS',                sol_name: 'Beneficios' },
  }
  return get(products, `${id}.${prop}`, '') 
}

export function getPropsByKeyword(prop, keyword){
  const products = {
    ["Movilidad"]:    { keyword: 'Movilidad',   prod_short_name: 'Movilidad', prod_name: 'Movilidad'},
    ["Hogar"]:        { keyword: 'Hogar',       prod_short_name: 'Hogar',     prod_name: 'Hogar Total'},
    ["PES"]:          { keyword: 'PES',         prod_short_name: 'PES',       prod_name: 'Plan Empresario Sura'},
    ["RespCivil"]:    { keyword: 'RespCivil',   prod_short_name: 'RC',        prod_name: 'Respaldo por Daños a Terceros'},
    ["AlaAzul"]:      { keyword: 'AlaAzul',     prod_short_name: 'AA',        prod_name: 'Ala Azul'},
    ["AlaAzulPlus"]:  { keyword: 'AlaAzulPlus', prod_short_name: 'AA+',       prod_name: 'Ala Azul Plus'},
    ["PlanVive"]:     { keyword: 'PlanVive',    prod_short_name: 'P Vive',    prod_name: 'Plan Vive'},
  }
  return (!keyword || keyword === '') ? '' : get(products, `${keyword}.${prop}`, '')
}

/**
 * lockedSuraAction - Function return locked sura action
 * @param {number} rolId user rol id
 * @param {object} configurationObject object with allowed user actions
 * @return {boolean} return true if the action is locked, return false if the action is allowed
 */
 export function lockedSuraAction(rolId, configurationObject) {
  const allowedAction = configurationObject;
  const action = allowedAction[rolId]
  return action === undefined ? true : action;
}


// WEBPACK FOOTER //
// ./src/libs/utils.js